var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showBar)?_c('div',[_c('div',{staticClass:"h-24 bg-beige fixed bottom-0 left-0 w-full z-50 p-4 flex items-center shadow"},[_c('div',{staticClass:"container flex justify-between items-center"},[_c('h4',{staticClass:"lg:block hidden text-black"},[_vm._v(_vm._s(_vm.item.name[_vm.trans.locale]))]),_vm._v(" "),_vm._t("default")],2)])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }